@if (!tyvisoMsg) {
  <div class="close-btn-wrapper" mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()" class="cross-btn"><img src="assets/images/cross-img.png" alt="close" /></button>
  </div>
}
<div
  class="message-wrapper"
  [ngClass]="{
    'wrapper-no-padding': plunkoWimbeldonStatus || plunkoChristmasStatus || newSjPrizeStatus || plunkoValentinesStatus || plunkoEasterStatus,
    'message-wrapper--tyviso': tyvisoMsg
  }"
>
  <h1 [ngClass]="plunkoWimbeldonStatus || plunkoChristmasStatus || versionMessage || inboxChurnRisk || plunkoValentinesStatus || plunkoEasterStatus || checkListMsg || promotionMsg || tyvisoMsg ? 'message-text-disable' : ''">Message</h1>
  @if (versionMessage) {
    <h1>{{data?.Title}}</h1>
  }
  @if (tyvisoMsg) {
    <div class="tyviso-sheet">
      <div class="tyviso-sheet-top">
        <div class="tyviso-handle" aria-hidden="true"></div>
        <div class="tyviso-header">
          <div class="tyviso-header-text">
            <h1 class="tyviso-title">Claim a gift on us now.</h1>
            <p class="tyviso-description">Claim as many offers as you like.</p>
          </div>
          <button type="button" class="tyviso-close" (click)="closeDialog()" aria-label="Close">
            <svg class="tyviso-close-icon" viewBox="0 0 14 14" aria-hidden="true" focusable="false">
              <path
                d="M7 7.81689l-2.85742 2.85743q-0.16064 0.16065-0.41016 0.16064-0.24609 0-0.40674-0.16064-0.16064-0.16064-0.16064-0.40674 0-0.24951 0.16064-0.41016l2.85743-2.85742-2.85743-2.85742q-0.16064-0.16064-0.16064-0.40674 0-0.24951 0.16064-0.41016 0.16064-0.16064 0.40674-0.16064 0.24951 0 0.41016 0.16064l2.85742 2.85743 2.85742-2.85743q0.16064-0.16064 0.40674-0.16064 0.24951 0 0.41016 0.16064 0.16065 0.16064 0.16064 0.41016 0 0.24609-0.16064 0.40674l-2.85743 2.85742 2.85743 2.85742q0.16065 0.16064 0.16064 0.41016 0 0.24609-0.16064 0.40674-0.16064 0.16065-0.41016 0.16064-0.24609 0-0.40674-0.16064l-2.85742-2.85743z"
                fill="#2D3142"
              ></path>
            </svg>
          </button>
        </div>
      </div>
      <div class="tyviso-offers" role="list">
        @if (!tyvisoOffers?.length) {
          <p class="tyviso-empty">No offers available right now.</p>
        }
        @for (offer of tyvisoOffers; track offer?.id || offer?.url) {
          <article class="tyviso-offer" role="listitem">
            <div class="tyviso-offer-media">
              @if (offer?.image) {
                <img
                  class="tyviso-offer-image"
                  [src]="offer.image"
                  [alt]="offer?.title || 'Offer'"
                  (error)="onTyvisoImageError($event)"
                />
              } @else {
                <div class="tyviso-offer-image tyviso-offer-image--placeholder" aria-hidden="true"></div>
              }
              @if (offer?.partnerLogo) {
                <div class="tyviso-logo-badge">
                  <img
                    class="tyviso-partner-logo"
                    [src]="offer.partnerLogo"
                    [alt]="offer?.title || 'Partner'"
                    (error)="onTyvisoImageError($event)"
                  />
                </div>
              }
            </div>
            <div class="tyviso-offer-body">
              @if (offer?.title) {
                <h2 class="tyviso-offer-title">{{ offer.title }}</h2>
              }
              @if (offer?.description) {
                <p class="tyviso-offer-description">{{ offer.description }}</p>
              }
              <div class="tyviso-action-row">
                <button
                  type="button"
                  class="tyviso-claim"
                  (click)="openTyvisoOffer(offer?.url)"
                >
                  {{ offer?.cta || data?.button_label || 'Claim now' }} →
                </button>
                @if (hasTyvisoTerms(offer)) {
                  <button
                    type="button"
                    class="tyviso-terms-toggle"
                    [attr.aria-expanded]="isTyvisoTermsExpanded(offer, $index)"
                    [attr.aria-controls]="tyvisoTermsPanelId(offer, $index)"
                    (click)="toggleTyvisoTerms(offer, $index, $event)"
                  >
                    Terms
                    <svg
                      class="tyviso-terms-chevron"
                      [class.tyviso-terms-chevron--open]="isTyvisoTermsExpanded(offer, $index)"
                      viewBox="0 0 12 12"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path
                        d="M2.25 4.5L6 8.25L9.75 4.5"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </button>
                }
              </div>
              @if (hasTyvisoTerms(offer) && isTyvisoTermsExpanded(offer, $index)) {
                <div
                  class="tyviso-terms-panel"
                  [id]="tyvisoTermsPanelId(offer, $index)"
                  role="region"
                  aria-label="Offer terms"
                >
                  <p class="tyviso-terms-text">{{ offer.terms }}</p>
                </div>
              }
            </div>
          </article>
        }
      </div>
    </div>
  } @else {
    <div #dynamicContent class="message_content" [innerHTML]="data?.message_content | safeHtml"></div>
    @if (data?.icon) {
      <img [src]="data?.icon" />
    }
    @if (inboxChurnRisk || promotionMsg) {
      <div [innerHTML]="(data?.content[selectedLanguage]?.description || data.content[defaultLanguage]?.description) | safeHtml"></div>
    }
    @if (checkListMsg) {
      <div [innerHTML]="(data.content[selectedLanguage]?.description || data.content[defaultLanguage]?.description) | safeHtml"></div>
    }
    @if (!promotionMsg) {
      <div class="foot-wrapper inbox_button">
        @if (inboxChurnRisk) {
          <ion-button class="capsule-btn" expand="block" (click)="navigateTo(data?.destination)">
            {{
            data?.content && data?.content[selectedLanguage]?.button_label
            ? data?.content[selectedLanguage]?.button_label
            : data?.button_label
            }}
          </ion-button>
        }
      </div>
    }
    @if (promotionMsg) {
      <div class="foot-wrapper-promo inbox_button">
        <ion-button class="capsule-promot-btn" expand="block" (click)="openUrl(data?.destination)">
          {{
          data?.content && data?.content[selectedLanguage]?.button_label
          ? data?.content[selectedLanguage]?.button_label
          : data?.button_label
          }}
        </ion-button>
      </div>
    }
    <div class="foot-wrapper inbox_button" [ngClass]="{'foot-wrapper-wimbeldon': plunkoWimbeldonStatus, 'foot-wrapper-christmas': plunkoChristmasStatus, 'cta-wrapper-left': mustWinTemplate}">
      @if (!newSjPrizeStatus && !promotionMsg) {
        <ion-button class="capsule-btn" [ngClass]="plunkoWimbeldonStatus || plunkoChristmasStatus || plunkoValentinesStatus || plunkoEasterStatus ? 'capsule-btn-wimbeldon' : ''" expand="block" (click)="openUrl(data?.destination)">
        {{ data?.button_label }}</ion-button>
      }
    </div>
  }
</div>
